import { BlockContentsDTO } from '../../../server/dto/BlockContentsDTO';


import { UserBlockContents } from '../../../server/dto/generated/UserBlockContents';


import { PageContents } from '../../../server/dto/PageContents';


import { GeneratedBizBase } from '../../../framework/frontend/GeneratedBizBase';


import { Response } from '../../../framework/biz/Response';


 // サーバーサイドコードへのリンク(このコードは実行されません)
const __non_exec_code = async () => {
  // import("../../../server/biz/BlocklyService");
};

export class BlocklyService extends GeneratedBizBase{
  async addNew(user_id: number,project_id: string,title: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/addNew', arguments);
  }
  async addNewClassMemberContains(user_id: number,member_id: number,project_id: string,title: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/addNewClassMemberContains', arguments);
  }
  async save(user_id: number,project_id: string,title: string,block_xml: string,block_code: string,js_code: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/save', arguments);
  }
  async saveImage(project_id: string,user_id: number,imgBase64: string): Promise<Response<string>> {
    return super.restCall<Response<string>>('post', '/v1/BlocklyService/saveImage', arguments);
  }
  async duplicate(project_id: string,user_id: number,new_project_id: string): Promise<any> {
    return super.restCall<any>('post', '/v1/BlocklyService/duplicate', arguments);
  }
  async list(user_id: number): Promise<Response<BlockContentsDTO[]>> {
    return super.restCall<Response<BlockContentsDTO[]>>('get', '/v1/BlocklyService/list', arguments);
  }
  async presentationList(user_id: number,class_name: string): Promise<Response<BlockContentsDTO[]>> {
    return super.restCall<Response<BlockContentsDTO[]>>('get', '/v1/BlocklyService/presentationList', arguments);
  }
  async listForClass(user_id: number,member_id: number): Promise<Response<UserBlockContents[]>> {
    return super.restCall<Response<UserBlockContents[]>>('get', '/v1/BlocklyService/listForClass', arguments);
  }
  async saveXml(user_id: number,project_id: string,block_xml: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/saveXml', arguments);
  }
  async page(id: string,user_id: number): Promise<Response<PageContents>> {
    return super.restCall<Response<PageContents>>('get', '/v1/BlocklyService/page', arguments);
  }
  async deleteProject(project_id: string,user_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/deleteProject', arguments);
  }
  async publish(project_id: string,target: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/publish', arguments);
  }
  async editTitle(project_id: string,title: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/BlocklyService/editTitle', arguments);
  }
}
